import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState, useMemo } from "react";
import {
  faInstagram,
  faLinkedin,
  faMedium,
} from "@fortawesome/free-brands-svg-icons";
import { ShinyButton } from "./ui/shiny-button";
import LivingVineBackground from "../LivingVine/LivingVineBackground";
import VerticalFloatingDock from "./ui/VerticalFloatingDock";
import {
  IconHome,
  IconUser,
  IconLayoutGrid,
  IconCalendarEvent,
  IconBook,
  IconUsers,
  IconPhoto,
  IconPhone,
} from "@tabler/icons-react";

const MainPageHomeSection = ({
  onScrollToTop,
  hideTitle = false,
  hideHomeText = false,
  embedded = false,
  scaleInnerText = false,
}) => {
  const [changingText, setChangingText] = useState("");
  const words = useMemo(() => ["INNOVATIVE", "CONNECTED", "EMPOWERING"], []);
  const typingSpeed = 150;
  const wordPause = 1000;

  useEffect(() => {
    let wordIndex = 0;
    let letterIndex = 0;
    let isTyping = true;

    const typeLetters = () => {
      if (isTyping) {
        setChangingText(() => words[wordIndex].substring(0, letterIndex + 1));
        letterIndex++;

        if (letterIndex === words[wordIndex].length) {
          isTyping = false;
          setTimeout(() => typeLetters(), wordPause);
        } else {
          setTimeout(typeLetters, typingSpeed);
        }
      } else {
        letterIndex = 0;
        wordIndex = (wordIndex + 1) % words.length;
        isTyping = true;
        typeLetters();
      }
    };

    typeLetters();
    return () => {};
  }, [words]);

  const socialLinks = [
    {
      title: "Blog",
      icon: <FontAwesomeIcon icon={faMedium} className="dock-icon" />,
      href: "https://ieee-tems-blogs.medium.com/",
    },
    {
      title: "Instagram",
      icon: <FontAwesomeIcon icon={faInstagram} className="dock-icon" />,
      href: "https://www.instagram.com/ieeetemsvit/",
    },
    {
      title: "LinkedIn",
      icon: <FontAwesomeIcon icon={faLinkedin} className="dock-icon" />,
      href: "https://www.linkedin.com/company/ieee-tems/about/",
    },
  ];

  const menuLinks = [
    { title: "Home", icon: <IconHome className="dock-icon" />, href: "#Home" },
    { title: "About Us", icon: <IconUser className="dock-icon" />, href: "#About" },
    { title: "Domains", icon: <IconLayoutGrid className="dock-icon" />, href: "#Domains" },
    { title: "Events", icon: <IconCalendarEvent className="dock-icon" />, href: "#Events" },
    { title: "Blogs", icon: <IconBook className="dock-icon" />, href: "#Blog" },
    { title: "Board", icon: <IconUsers className="dock-icon" />, href: "#Board" },
    { title: "Memories", icon: <IconPhoto className="dock-icon" />, href: "#Memories" },
    { title: "Contact Us", icon: <IconPhone className="dock-icon" />, href: "#ContactSection" },
  ];

  const handleTitleClick = (e) => {
    e.preventDefault();
    if (onScrollToTop) {
      onScrollToTop();
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <section
      id="Home"
      className={embedded ? "home-portal-section" : ""}
      style={{
        /* dark grey hero with a subtle white dot grid */
        backgroundColor: "#1E1E1E",
        backgroundImage:
          "radial-gradient(circle, rgba(255, 255, 255, 0.10) 1px, transparent 1.5px)",
        backgroundSize: "28px 28px",
        backgroundPosition: "0 0",
        height: embedded ? "100%" : "100vh",
        position: "relative",
        zIndex: 1,
      }}
    >
      <LivingVineBackground
        vineColor="rgba(255, 255, 255, 0.95)"
        branchColor="rgba(255, 255, 255, 0.6)"
        maxBranchLength={190}
        className={embedded ? "home-portal-vine" : ""}
      >
        <div id="homecontent">
          <div
            className={
              scaleInnerText
                ? 'home-portal-center home-portal-center--scaling'
                : embedded
                  ? 'home-portal-center'
                  : ''
            }
          >
            {!hideTitle && (
              <a
                href="#top"
                onClick={handleTitleClick}
                style={{ textDecoration: 'none' }}
              >
                <div id="htitle">IEEE TEMS</div>
              </a>
            )}
            {!hideHomeText && <p id="hchanging">{changingText}</p>}
          </div>

          <div id="headerBar">
            <ShinyButton
              href="https://vit.ac.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="main-vit-button"
            >
              <img src="/VIT Logo.webp" alt="VIT Logo" className="main-vit-logo" />
            </ShinyButton>

            <ShinyButton
              href="https://vit.ac.in/campuslife/studentswelfare"
              target="_blank"
              rel="noopener noreferrer"
              className="main-osw-button"
            >
              Office of Students' Welfare
            </ShinyButton>
          </div>
        </div>
      </LivingVineBackground>
      {!embedded && (
        <>
          <div className="social-dock-wrap">
            <VerticalFloatingDock items={socialLinks} side="left" />
          </div>
          <div className="page-menu-dock-wrap">
            <VerticalFloatingDock items={menuLinks} side="right" />
          </div>
        </>
      )}
    </section>
  );
};

export default MainPageHomeSection;
